module.exports = __webpack_public_path__ + "static/media/IMG_2997a.a8057f87.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/cycle/andes/IMG_2997a.jpg
// module id = 145
// module chunks = 0